import { useCallback, useSyncExternalStore } from "react";

/**
 * True while the media query matches. It reads matchMedia during render, so the first client render already has
 * the right answer and nothing re-lays out after mount. False on a server and where matchMedia is missing.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener?.("change", onChange);
      return () => mql.removeEventListener?.("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => (typeof window !== "undefined" && !!window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** Phones: under Tailwind's md breakpoint (768px). */
export const PHONE_QUERY = "(max-width: 767px)";
